// extracted by mini-css-extract-plugin
export default {"wrapper":"input_wrapper__69cnI","input":"input_input__HeWEv"};